/**
 * Utility functions for handling PWA manifest
 */

/**
 * Gets the correct manifest URL based on PUBLIC_URL environment variable
 */
export function getManifestUrl(): string {
  const publicUrl = import.meta.env.BASE_URL || '';
  const cleanPublicUrl = publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;
  return `${cleanPublicUrl}/manifest.json`;
}

/**
 * Validates that the manifest exists and is accessible
 */
export async function validateManifestExists(manifestUrl: string): Promise<boolean> {
  try {
    const response = await fetch(manifestUrl);
    if (!response.ok) {
      throw new Error(`Manifest not found: ${response.status}`);
    }
    return true;
  } catch (error) {
    throw error;
  }
}
